import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import '../pages.scss';
import Logo from '../../components/logo.mjs';


const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [resetError, setResetError] = useState(false);
    const [emailEmpty, setEmailEmpty] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        var emailElem = document.getElementById("email");

        if (email === '') {
            emailElem.style.border = 'solid 3px #C40000';
            setEmailEmpty(true);
            return;
        } 

        setEmailEmpty(false);
        emailElem.style.border = '';

        const body = JSON.stringify({
            "meta": {
                "email": email,
                "deliver": true,
            }
        })

        await fetch(`https://api.keygen.sh/v1/accounts/33459a88-6b71-4ab6-83db-e2ec6c252baf/passwords`, {
            method: "POST",
            headers: {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/vnd.api+json",
            },
            body: body
        })
        .then(data => {
            if (data.ok) {
                var modal = document.querySelector(".modal");
                modal.classList.remove("hidden");
                var overlay = document.querySelector(".overlay");
                overlay.classList.remove("hidden");
            } else {
                setResetError(true);
            }
        })
        .catch(error => console.log(error));
    }

    const handleLoginNav = () => {
        navigate("/");
    }


    return (
        <>
        <div className="overlay hidden"></div>
        <section className="modal hidden">
        <div className="forgotModal">
                <p style={{paddingBottom:'50px', width:'85%', fontSize:'16px', textAlign:'center', margin:'auto', marginTop:'85px'}}>A password reset link has been sent to your email.</p>
                <button style={{width:'70%', fontSize:'16px'}} className="btn" onClick={handleLoginNav}>Back to Log in</button>
            </div>
        </section>

        <div className="page" id="page">
            <div style={{marginBottom:'0px', paddingBottom:'0px'}}>
                {Logo()}
            </div>
            <div style={{margin:'auto'}}>
                <p style={{margin:'auto', marginBottom:'12px'}} className="title">Reset your password</p>
                <p style={{margin:'auto', marginBottom:'45px', fontSize:'18px'}}>Enter your email address to receive a link to reset your password.</p>
            </div>
            <i className="infoIcon" style={resetError ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
            <p className="errorP" style={resetError ? {display: 'inline-block', fontSize:'16px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>Something went wrong. Please refresh and try again.</p>
            <div id="loginForm">
                <p htmlFor="email" style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left', marginTop:'40px'}}>Email address</p>
                <input style={{marginTop:'0px'}} type="text" id="email" name="email" onChange={(e) => {setEmail(e.target.value)}} onPaste={(e) => e.preventDefault()} autocomplete="off" required placeholder="example@domain.com"></input>
                <div style={{display:'inline-block'}}>
                    <i className="infoIcon" style={emailEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={emailEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                </div>

                <button className="btn" style={{marginTop:'20px'}} onClick={(e) => handleSubmit(e)}>Reset password</button>
            </div>
            <div style={{float:'left', marginTop:'60px'}} onClick={handleLoginNav}>
                <i style={{display:'inline-block', height:'20px', marginRight:"5px", verticalAlign:'bottom', cursor:'pointer'}}><span class="material-symbols-outlined">west</span></i>
                <p style={{border:'none', background:'none', fontSize:'16px', display:'inline-block', verticalAlign:'bottom', cursor:'pointer', height:'20px', marginBottom:'0px'}}>Back to Log in</p>
            </div>
        </div>
        </>
    );
};

export default ForgotPasswordPage;